<template>
    <fade-transition :delay="delay" :duration="{enter:500}">
        <div v-show="show" :class="classes">
            <div v-if="contact.title.length" class="content__sectionTitle">
                {{contact.title}}
            </div>

            <div class="content__info">
                <ul class="content__listWrapper">
                    <li v-for="content_ in contact.content" class="content__list">
                        <img class="" :src="content_.url" :alt="content_.name">
                    </li>
                </ul>
            </div>
        </div>
    </fade-transition>
</template>

<script>
    import {preloadImg} from '../utils/shared'

    export default {
        props: [
            'contact',
            'delay',
        ],
        data() {
            return {
                show: false,
            }
        },
        computed: {
            classes() {
                return [
                    'content__section content__section-ourSpace',
                    {'content__section-withTitle': this.contact.title.length},
                ]
            },
        },
        mounted() {
            let all = this.contact.content.map((content) => {
                return preloadImg(content.url).catch(() => {})
            })

            Promise.all(all)
                .then(() => {
                    this.show = true
                })
        },
        methods: {

        }
    }
</script>
